/**
 * Application Configuration
 * Contains environment variables and app-wide constants
 */

/**
 * Monkey Barber Club Franchise ID
 * This is the main franchise ID for the Monkey Barber Club landing page
 */
export const MONKEY_FRANCHISE_ID = import.meta.env.VITE_MONKEY_FRANCHISE_ID || 'lILDGxMgfsifzpqg4YZu';

/**
 * Check if a franchise ID belongs to Monkey Barber Club
 */
export const isMonkeyFranchise = (franchiseId: string): boolean => {
  return franchiseId === MONKEY_FRANCHISE_ID;
};
